import { render, staticRenderFns } from "./wjtpay.vue?vue&type=template&id=dc38631e&scoped=true"
import script from "./wjtpay.vue?vue&type=script&lang=js"
export * from "./wjtpay.vue?vue&type=script&lang=js"
import style0 from "./wjtpay.vue?vue&type=style&index=0&id=dc38631e&prod&scoped=true&lang=css"
import style1 from "./wjtpay.vue?vue&type=style&index=1&id=dc38631e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc38631e",
  null
  
)

export default component.exports